import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-bread-crumbs',
  templateUrl: './bread-crumbs.component.html',
  styleUrls: ['./bread-crumbs.component.scss']
})
export class BreadcrumbsComponent {

  private _startCategoryId: number = null;

  @Input() set startCategoryId(value: number) {
    this._startCategoryId = value;
    this.fill();
  }
  @Output() currentCatChanged = new EventEmitter<string[]>();
  get startCategoryId(): number {
    return this._startCategoryId;
  }

  constructor(
    public router: Router,
    private http: HttpClient,
    public appService: AppService, public activatedRoute: ActivatedRoute) { }

  breadcrumbsList: [BreadCrumb];

  getBreadcrumps(catId: number) {
    this.http.get<[BreadCrumb]>(this.appService.baseUrl + '/api/categories/breadcrumbs/' + catId)
      .subscribe(data => {
        this.breadcrumbsList = data;
        this.currentCatChanged.emit(data.map(x => x.title));
      });
  }

  fill() {
    this.getBreadcrumps(this.startCategoryId);
  }
}
export class BreadCrumb {
  id: number;
  title: string;
}




